import { render } from "./Apartments.vue?vue&type=template&id=23a6aaba"
import script from "./Apartments.vue?vue&type=script&lang=js"
export * from "./Apartments.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__